import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { useFormFieldControl } from "../FormField/FormFieldContext.js";
/* empty css             */
import { forwardRef, useCallback, useLayoutEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Checkbox/Checkbox.tsx
function setRef(ref, value) {
	if (typeof ref === "function") ref(value);
	else if (ref) ref.current = value;
}
/**
* A native checkbox, drawn with the brand's box and mark, with an optional label: an
* independent on/off choice. `className` goes on the label; every other prop, and the
* ref, go to the `<input>`.
*/
var Checkbox = forwardRef(function Checkbox({ label, indeterminate = false, invalid: invalidProp, disabled, className, id: idProp, "aria-describedby": describedByProp, ...rest }, ref) {
	const { id, "aria-describedby": describedBy, invalid } = useFormFieldControl({
		id: idProp,
		"aria-describedby": describedByProp,
		invalid: invalidProp
	});
	const input = useRef(null);
	const setInput = useCallback((node) => {
		input.current = node;
		setRef(ref, node);
	}, [ref]);
	useLayoutEffect(() => {
		if (input.current) input.current.indeterminate = indeterminate;
	}, [indeterminate]);
	return /* @__PURE__ */ jsxs("label", {
		className: cx("ds-checkbox", invalid && "ds-checkbox--invalid", disabled && "ds-checkbox--disabled", className),
		children: [/* @__PURE__ */ jsxs("span", {
			className: "ds-checkbox__box",
			children: [/* @__PURE__ */ jsx("input", {
				ref: setInput,
				type: "checkbox",
				className: "ds-checkbox__input",
				id,
				disabled,
				"aria-invalid": invalid || void 0,
				"aria-describedby": describedBy,
				...rest
			}), /* @__PURE__ */ jsx(Icon, {
				name: indeterminate ? "minus" : "check",
				className: "ds-checkbox__mark",
				strokeWidth: 3
			})]
		}), label != null && /* @__PURE__ */ jsx("span", {
			className: "ds-checkbox__label",
			children: label
		})]
	});
});
//#endregion
export { Checkbox };

//# sourceMappingURL=Checkbox.js.map